import { render } from "./PrintHeaderDesign4.vue?vue&type=template&id=3e03464a&scoped=true"
import script from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"
export * from "./PrintHeaderDesign4.vue?vue&type=script&lang=js"

import "./PrintHeaderDesign4.vue?vue&type=style&index=0&id=3e03464a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e03464a"]])

export default __exports__